.container {
    background: white;
    margin-top: 0.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    padding-top: 60px;
}

.text-container {
    position: absolute;
    top: -60px;
}
